import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { QuotationStateFlowProps } from "models/propTypes/quotationPropTypes";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useQuotesService } from "serviceHooks";
//#endregion

const QuotationStateFlow: React.FC<QuotationStateFlowProps> = (props) => {
  const quotesService = useQuotesService();
  const { getMounted } = useMountedState();
  const { serialNumber } = props;

  const [states, setStates] = React.useState<WintSuperkollAPIModel.EntityStateLog[]>();

  React.useEffect(() => {
    quotesService.getStateLogs(serialNumber).then((items) => {
      if (getMounted()) {
        setStates(items);
      }
    });
  }, [serialNumber]);

  return <>{states && <LinearStateFlowContainer steps={states} translationKey={"Quotation.StateFlowState"} />}</>;
};

export default QuotationStateFlow;
